module.exports = __webpack_public_path__ + "img/file.9df2be5c.svg";